import { Expose } from 'class-transformer';

export default class WorkReferenceFormError {
    nurse_id: string[] = []
    reference_name: string[] = []
    patient_communication: string[] = []
    scaling_and_polishing: string[] = []
    infection_control_procedures: string[] = []
    record_keeping_and_documentation: string[] = []
    time_management: string[] = []
    teamwork_and_collaboration: string[] = []
    professionalism: string[] = []
    comments: string[] = []
    @Expose({ name: '_schema' }) schema: string[] = []
}